﻿import { mediaSlider } from './vendor/lib/mediaslider/src/mediaslider.module.js';

export class ARTSlider {
    constructor() {}

    static initSliders() {
        // let sliders = [];
        let sliders = document.querySelectorAll('[data-op-slide]');

        Array.from(sliders).forEach(slider => {

            let autoplaySlider = slider.closest('[data-slider-play-time]');
            let sliderType = slider.getAttribute('data-op-slide');
            let slideCount = slider.childElementCount;

            let outerWrapper = slider.closest('[data-op-carousel-wrapper]');
            if(outerWrapper) {
                outerWrapper.classList.add('techno-slider-pending');
                outerWrapper.setAttribute('data-op-slide-count', slideCount);

                // default configuration
                let gutter = 0;
                let nav = true;
                let autoplay =  autoplaySlider ? true : false;
                let loop = autoplaySlider ? true : false;
                let autoplayTimeout = autoplaySlider ? parseInt(autoplaySlider.getAttribute('data-slider-play-time')) : 0;
                let responsive = {};
                // 'xs': 480px,
                // 's': 640px,
                // 'm': 800px,
                // 'l': 1024px,
                // 'xl': 1280px,
                // 'xxl': 1440px,
                // 'xxxl': 1680px
                if (sliderType === "brands"){
                    responsive = {
                       1: {
                           slideBy: 1.5,
                           items: 1.5
                       },
                       480: {
                           slideBy: 2.5,
                           items: 2.5
                       },
                       800: {
                           slideBy: 3,
                           items: 3
                       },
                       1024: {
                           slideBy: 4,
                           items: 4
                       }
                   };
                }
                else if (sliderType === "articles"){
                    responsive = {
                       1: {
                           slideBy: 1,
                           items: 2,
                       },
                       600: {
                           slideBy: 2.5,
                           items: 2.5,
                       },
                       800: {
                           slideBy: 3,
                           items: 3,
                       },
                       1170: {
                           slideBy: 4,
                           items: 4,
                       }
                   };
                }
                else if (sliderType === 'thumbnails') {
                    responsive = {
                        1: {
                            slideBy: 1,
                            items: 1
                        },
                        800: {
                            slideBy: 4,
                            items: 4,
                            disable : true
                        }
                    };
                }

                let sliderObject = mediaSlider({
                    autoplay: autoplay,
                    container: slider,
                    mode: 'carousel',
                    touch: true,
                    mouseDrag: false,
                    loop: loop,
                    speed: 1200,
                    autoplayTimeout: autoplayTimeout,
                    controls: true,
                    controlsText: ['',''],
                    autoplayButton: false,
                    autoplayButtonOutput: false,
                    gutter: gutter,
                    freezable: false,
                    fixedWidth: false,
                    nav: nav,
                    responsive: responsive,
                    onInit: (info) => this.checkNavDisplayState(info, outerWrapper),
                    onResize: (info) => this.checkNavDisplayState(info, outerWrapper)
                });

                if(sliderObject) {
                    outerWrapper.classList.add('techno-slider-initialized');
                    outerWrapper.classList.add('opc-carousel');
                    outerWrapper.setAttribute('data-op-slider-type', sliderType);
                    outerWrapper.classList.remove('techno-slider-pending');

                }
                slider.removeAttribute('data-op-slide');

            }
        });

    }

    /**
     * Überprüfen, ob Navigation angezeigt werden soll. Wenn nicht gescrollt werden muss, um alle Slides zu sehen, soll die
     * Navigation ausgebelendet werden
     */
    static checkNavDisplayState(info, outerWrapper) {
        console.log("info.items <= info.slideCount: ", info.items <= info.slideCount);
        const controls = outerWrapper.querySelector('.op-mediaslider-controls');
        const nav = outerWrapper.querySelector('.op-mediaslider-nav');

        if(info.items >= info.slideCount) {
            // hide nav
            controls.hidden = true;
            nav.hidden = true;
        } else {
            // display nav
            controls.hidden = false;
            nav.hidden = false;
        }
    }
}

